var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154.135,
    height: 115,
    viewBox: "0 0 154.135 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b0bec5;}.b,.c,.d{fill:none;}.b,.c{stroke:#b0bec5;stroke-width:5px;}.c{stroke-dasharray:5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1113.865 -361.932)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6,0H77a6,6,0,0,1,6,6V57a6,6,0,0,1-6,6H6a6,6,0,0,1-6-6V6A6,6,0,0,1,6,0Z",
    transform: "translate(1155.802 393.932)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6,0H77a6,6,0,0,1,6,6v4a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V6A6,6,0,0,1,6,0Z",
    transform: "translate(1155.802 466.932)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H83a0,0,0,0,1,0,0V16a6,6,0,0,1-6,6H6a6,6,0,0,1-6-6V0A0,0,0,0,1,0,0Z",
    transform: "translate(1155.802 361.932)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1113.865 417.746)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 26.237,
    transform: "translate(0 7.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.854,0l7.854,13.824H0Z",
    transform: "translate(37.547) rotate(90)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 29.335,
    transform: "translate(1238.53 437.287)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 29.335,
    transform: "translate(1238.53 423.287)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 29.335,
    transform: "translate(1238.53 409.287)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 154,
    height: 115,
    transform: "translate(1114 361.932)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgStep1);
export default __webpack_public_path__ + "static/media/img_step1.e1a20f55105b3cf88488e991cb2951eb.svg";
export { ForwardRef as ReactComponent };